:host {
  --z-searchbar-tag-text-color: var(--color-primary03);
  --z-searchbar-tag-bg: var(--color-hover-primary);
  --z-searchbar-item-height: 44px;

  z-index: 15;
  display: flex;
  column-gap: calc(var(--space-unit) * 2);
  font-family: var(--font-family-sans);
  font-weight: var(--font-rg);
}

:host,
* {
  box-sizing: border-box;
}

:host::part(list-item-container) {
  display: block;
  min-height: unset;
  padding: 0;
}

.input-container {
  position: relative;
  display: flex;
  width: 100%;
  flex-direction: column;
}

.results-wrapper {
  position: absolute;
  top: calc(100% - 1px);
  left: 0;
  width: 100%;
  padding: calc(var(--space-unit) / 4);
  border: var(--border-size-small) solid var(--color-surface03);
  border-top: none;
  background: var(--color-surface01);
}

.results {
  overflow: auto;
  max-height: var(--z-searchbar-results-height, 540px);
  padding: calc(var(--space-unit) / 2) calc(var(--space-unit) * 1.5);
  scrollbar-color: var(--color-primary01) transparent;
}

.results::-webkit-scrollbar {
  width: 10px;
  background: linear-gradient(to right, transparent 0 3px, var(--gray200) 3px 7px, transparent 7px 10px);
  border-radius: var(--border-radius);
}

.results::-webkit-scrollbar-track {
  background-color: transparent;
}

.results::-webkit-scrollbar-thumb {
  width: 10px;
  background-color: var(--color-primary01);
  border-radius: var(--border-radius);
}

.results .category-heading {
  display: block;
  font-size: var(--font-size-2);
  font-weight: var(--font-rg);
  line-height: var(--font-size-3);
}

.results .category-heading > * {
  display: block;
}

.results .category-heading > .category {
  color: var(--color-text05);
  font-style: italic;
}

.results .category-heading > .subcategory {
  margin-top: var(--space-unit);
  color: var(--color-default-text);
  text-transform: uppercase;
}

.results z-list-element {
  position: relative;
  display: block;
}

z-list-element > .item-search {
  padding: var(--space-unit) 0;
}

z-list z-list-element::before {
  position: absolute;
  z-index: 100;
  top: 5px;
  left: -20px;
  width: 8px;
  height: 1em;
  border-bottom: 1px solid var(--color-disabled01-icon);
  border-left: 1px solid var(--color-disabled01-icon);
  content: "";
  cursor: pointer;
}

z-list z-list-element::after {
  position: absolute;
  z-index: 100;
  top: 5px;
  left: -20px;
  width: 8px;
  height: 100%;
  border-left: 1px solid var(--color-disabled01-icon);
  content: "";
  cursor: pointer;
}

z-list z-list-element:last-child::after {
  display: none;
}

z-list > z-list-element::before,
z-list > z-list-element::after,
z-list > z-list-group > z-list-element::before,
z-list > z-list-group > z-list-element::after {
  display: none;
}

z-list > div.children-node {
  padding-left: calc(var(--space-unit) * 3);
}

.results z-list-element > .list-element {
  display: flex;
  justify-content: space-between;
  padding: calc(var(--space-unit) * 1.25) 0;
  cursor: pointer;
}

.results z-list-element > .list-element:focus-visible {
  box-shadow: var(--shadow-focus-primary);
  outline: none;
}

.results z-list-element > .list-element .item.ellipsis {
  overflow: hidden;
}

.results z-list-element .list-element::after {
  position: absolute;
  top: 0;
  right: 0;
  display: block;
  width: 100%;
  height: 44px;
  content: "";
  transform: translateX(-100%);
}

.results z-list-element .list-element.focused.hovered::after {
  padding-left: 6px;
}

.results z-list-element > .list-element:hover,
.results z-list-element > .list-element:hover::after {
  background-color: var(--color-background);
  cursor: pointer;
}

.results z-list-element > .list-element > z-tag {
  border: 1px solid var(--gray800);
  font-size: var(--font-size-1);
  font-weight: var(--font-sb);

  --z-tag-bg: var(--z-searchbar-tag-bg);
  --z-tag-text-color: var(--z-searchbar-tag-text-color);
}

.results .item {
  --z-icon-height: 12px;
  --z-icon-width: 12px;

  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  color: var(--color-default-text);
  column-gap: calc(var(--space-unit) * 1.5);
  fill: var(--color-default-icon);
  font-size: var(--font-size-2);
  line-height: var(--font-size-6);
}

.results .item.ellipsis > .item-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.results .item > .item-label mark {
  background: var(--color-primary03);
}

.results .item.item-search {
  --z-icon-height: 16px;
  --z-icon-width: 16px;
}

.results .item-show-all {
  text-align: center;
}

.results .item-no-results {
  display: block;
  font-size: var(--font-size-2);
  font-style: italic;
  line-height: var(--font-size-5);
}

.results .item-no-results > ul {
  padding-left: calc(var(--space-unit) * 2);
  margin: var(--space-unit);
}

/* Tablet breakpoint */
@media (min-width: 768px) {
  .results .category-heading {
    font-size: var(--font-size-3);
    line-height: var(--font-size-6);
  }

  .results .item {
    font-size: var(--font-size-3);
    line-height: var(--font-size-6);
  }

  .results .item.item-search {
    --z-icon-height: 18px;
    --z-icon-width: 18px;
  }

  .results .item.ellipsis > .item-label {
    height: 24px;
  }

  .results z-list-element > .list-element > z-tag {
    min-width: max-content;
  }
}

/* Desktop breakpoint */
@media (min-width: 1152px) {
  .results .item {
    cursor: pointer;
  }

  .results .item-no-results {
    cursor: default;
    font-size: var(--font-size-3);
    line-height: var(--font-size-6);
  }
}

:host([size="small"]) .results :is(.item, .category-heading),
:host([size="x-small"]) .results :is(.item, .category-heading) {
  font-size: var(--font-size-2);
}

:host([size="small"]) .results .item:not(.has-category),
:host([size="x-small"]) .results .item:not(.has-category) {
  --z-icon-height: 16px;
  --z-icon-width: 16px;
}

:host([size="small"]) z-list-element > .list-element,
:host([size="small"]) z-list-element > .item-search {
  padding: calc(var(--space-unit) * 0.75) 0;
}

:host([size="x-small"]) z-list-element > .list-element,
:host([size="x-small"]) z-list-element > .item-search {
  padding: calc(var(--space-unit) / 2) 0;
}

:host([size="small"]) z-list-element .list-element::after {
  height: 36px;
}

:host([size="x-small"]) z-list-element .list-element::after {
  height: 32px;
}
